import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const artisanWhite: Collection = {
  id: 's-and-p-artisan-white',
  brandId: 'salt-and-pepper',
  brandName: 'Salt and Pepper',
  icon: 'logo_salt_pepper.png',
  title: 'Artisan White',
  subTitle: 'Stijlvol en feestelijk',
  banner: 'artisan-white/artisan_white_banner.jpg',
  items: [
    {
      id: 's-and-p-artisan-white-1',
      collectionImages: [
        {
          image: 'artisan-white/Artisan White_4.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false
        },
        {
          image: 'artisan-white/Artisan White.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false
        }
      ]
    },
    {
      id: 's-and-p-artisan-white-2',
      collectionImages: [
        {
          image: 'artisan-white/Artisan White_1.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false
        },
        {
          image: 'artisan-white/Artisan White_13.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false
        }
      ]
    }
  ],
  salesArticleIds: [
    'd0df28e8-a02d-46e2-af2d-fbd8ef41c515',
    'c41fe0ca-c80a-47aa-bd5d-878c3695c147',
    'cc75f1ed-dc93-4c91-b7fa-1baafbf75895',
    'f6480d9f-2806-4d3c-9874-dd36ad6d2f8b',
    'b3cffb0b-225b-4cbd-9065-10bc30451d9d',
    '0c23c17a-44b4-45ef-b6f6-5cbbf51a973e',
    '198e7725-9534-41ad-87b1-4eec3e5fbbb8',
    'be79a49f-3077-4580-9782-2dcfa6f70bd4',
    '01166c6f-6bab-4096-8461-5facfc2cd94f',
    'ffa0b79c-bd38-4baf-9dfb-9f9151c11f4f',
    '2f6033c5-2c48-4736-8a35-f3b3b841459b',
    '1e001f31-178d-43c8-8c97-0445dfd85269'
  ]
};
